import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { HC } from "../hr/theme";
import { Btn } from "../hr/ui";
import { DataTable } from "./crmui";
import { toast } from "sonner";
import { Download } from "lucide-react";

export default function CRMReports() {
  const [catalogue, setCatalogue] = useState([]);
  const [key, setKey] = useState("customer_growth");
  const [rep, setRep] = useState(null);
  const [dates, setDates] = useState({ date_from: "", date_to: "" });

  useEffect(() => { api.get("/crm/reports").then(setCatalogue).catch(() => {}); }, []);
  useEffect(() => {
    const params = {};
    if (dates.date_from) params.date_from = dates.date_from;
    if (dates.date_to) params.date_to = dates.date_to;
    api.get(`/crm/reports/${key}`, { params }).then(setRep).catch((e) => toast.error(formatApiError(e)));
  }, [key, dates]);

  const exportCsv = async () => {
    try {
      const res = await api.get(`/crm/reports/${key}/export`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([res], { type: "text/csv" }));
      const a = document.createElement("a"); a.href = url; a.download = `crm-${key}.csv`; a.click();
      toast.success("Report exported");
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="space-y-4" data-testid="crm-reports-page">
      <div className="rounded-2xl bg-white border p-3 flex flex-wrap items-center gap-2" style={{ borderColor: HC.border }}>
        <select value={key} onChange={(e) => setKey(e.target.value)} data-testid="report-select"
          className="h-9 px-2 rounded-md border text-[12.5px]" style={{ borderColor: HC.border }}>
          {catalogue.map((c) => <option key={c.key} value={c.key}>{c.label}</option>)}
        </select>
        <input type="date" value={dates.date_from} onChange={(e) => setDates({ ...dates, date_from: e.target.value })}
          data-testid="report-from" className="h-9 px-2 rounded-md border text-[12px]" style={{ borderColor: HC.border }} />
        <input type="date" value={dates.date_to} onChange={(e) => setDates({ ...dates, date_to: e.target.value })}
          data-testid="report-to" className="h-9 px-2 rounded-md border text-[12px]" style={{ borderColor: HC.border }} />
        <div className="flex-1" />
        <Btn variant="outline" onClick={exportCsv} data-testid="report-export"><Download size={14} /> Export CSV</Btn>
      </div>
      {rep && (
        <>
          <div className="text-[12px]" style={{ color: HC.soft }}>
            {rep.label} · {rep.period?.from} → {rep.period?.to} · {rep.rows.length} rows
          </div>
          <DataTable testid="crm-report-table" columns={rep.columns} rows={rep.rows}
            empty="No data for this report and period" />
        </>
      )}
    </div>
  );
}
